/**
 * Connecting a calendar asks Google for calendar.readonly, a scope Google reviews
 * individually, so until that review clears Google shows an "unverified app" interstitial.
 * Signing in never hits it -- that asks only for openid/email/profile.
 *
 * One line, deliberately. The point is only that the parent recognises the screen and knows
 * which button gets past it; anything longer reads as a security warning about our own app,
 * which is the opposite of reassuring. Revisit the wording before this goes to people who
 * do not already know what the app is.
 */
export function UnverifiedNotice() {
  return (
    <p className="muted" style={{ marginTop: 8 }}>
      Google will call this app unverified while review is pending — choose{' '}
      <em>Advanced</em>, then <em>Go to unschool.works</em>.
    </p>
  );
}
